import React, { useState, useRef } from 'react';
import axios from 'axios';

const MontagePanel = () => {
  const [montageType, setMontageType] = useState('concat');
  const [params, setParams] = useState({});
  const [files, setFiles] = useState([]);
  const [previewUrl, setPreviewUrl] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const videoRef = useRef(null);

  const handleParamChange = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleGenerate = async () => {
    setIsProcessing(true);
    const formData = new FormData();
    formData.append('type', montageType);
    files.forEach(file => formData.append('files', file));
    Object.entries(params).forEach(([key, value]) => formData.append(key, value));

    try {
      const res = await axios.post('/api/montage', formData, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'video/mp4' });
      setPreviewUrl(URL.createObjectURL(blob));
    } catch (error) {
      console.error(error);
    }
    setIsProcessing(false);
  };

  return (
    <div className="col-md-4">
      <div className="bg-white p-3 rounded shadow-sm border">
        <h5 className="text-secondary mb-3">🎞️ Montage Vidéo</h5>

        <div className="accordion" id="montageAccordion">

          {/* 📦 TYPE DE MONTAGE */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingType">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseType" aria-expanded="true" aria-controls="collapseType">
                📦 Type de montage
              </button>
            </h2>
            <div id="collapseType" className="accordion-collapse collapse show" data-bs-parent="#montageAccordion">
              <div className="accordion-body">
                <select className="form-select form-select-sm" value={montageType} onChange={(e) => setMontageType(e.target.value)}>
                  <option value="concat">📺 Concaténation</option>
                  <option value="trim">✂️ Découpe</option>
                  <option value="drawtext">📝 Texte</option>
                  <option value="overlay">🖼️ Overlay</option>
                  <option value="xfade">🎞️ Transition (fondu)</option>
                  <option value="speed">⏩ Vitesse</option>
                  <option value="slideshow">🖼️ Diaporama</option>
                </select>
              </div>
            </div>
          </div>

          {/* ⚙️ OPTIONS SPÉCIFIQUES */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOptions">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOptions" aria-expanded="false" aria-controls="collapseOptions">
                ⚙️ Options du montage
              </button>
            </h2>
            <div id="collapseOptions" className="accordion-collapse collapse" data-bs-parent="#montageAccordion">
              <div className="accordion-body">
                {/* Options spécifiques par type */}
                {montageType === 'trim' && (
                  <>
                    <input className="form-control form-control-sm mb-2" name="start" placeholder="⏱️ Début (ex: 00:00:10)" onChange={handleParamChange} />
                    <input className="form-control form-control-sm" name="end" placeholder="⏱️ Fin (ex: 00:00:30)" onChange={handleParamChange} />
                  </>
                )}
                {montageType === 'drawtext' && (
                  <input className="form-control form-control-sm" name="text" placeholder="📝 Texte à afficher" onChange={handleParamChange} />
                )}
                {montageType === 'overlay' && (
                  <input className="form-control form-control-sm" name="position" placeholder="📍 Position (ex: 10:10)" onChange={handleParamChange} />
                )}
                {montageType === 'speed' && (
                  <input className="form-control form-control-sm" name="factor" placeholder="⚡ Vitesse (ex: 0.5)" onChange={handleParamChange} />
                )}
              </div>
            </div>
          </div>

          {/* 📁 FICHIERS */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFiles">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiles" aria-expanded="false" aria-controls="collapseFiles">
                📁 Fichiers
              </button>
            </h2>
            <div id="collapseFiles" className="accordion-collapse collapse" data-bs-parent="#montageAccordion">
              <div className="accordion-body">
                <input className="form-control form-control-sm" type="file" multiple onChange={handleFileChange} />
              </div>
            </div>
          </div>

          {/* ▶️ BOUTON DE GÉNÉRATION */}
          <div className="accordion-item">
            <div className="accordion-body">
              <button className="btn btn-outline-primary w-100 mt-3" onClick={handleGenerate} disabled={isProcessing}>
                {isProcessing ? '⏳ Montage en cours...' : '🎬 Générer le montage'}
              </button>
            </div>
          </div>

          {/* 🔍 PRÉVISUALISATION */}
          {previewUrl && (
            <div className="accordion-item mt-3">
              <div className="accordion-body">
                <p className="text-muted small mb-1">🔍 Aperçu du montage :</p>
                <video ref={videoRef} controls src={previewUrl} className="w-100 rounded shadow-sm" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MontagePanel;
